/**
 * @author Ashish Dwivedi <ashish.dwivedi@314ecorp.com>
 * @description hook for Individual Invoice history
 */
import { useQuery, UseQueryResult } from '@tanstack/react-query';

import api from 'client/index';
import QUERY_KEYS from 'app-constants/queryKeys';

/**
 * use active subscription plans
 */
const useInvoiceHistory = (pageNumber?: number, pageSize?: number): UseQueryResult<Subscriptions.IInvoiceResponseModel, IAxiosError> => {
	return useQuery({
		queryKey: [QUERY_KEYS.invoiceHistory, { pageNumber, pageSize }],
		queryFn: async () => {
			const { data } = await api.Subscriptions.getInvoices({ pgNum: pageNumber, pgSize: pageSize });
			return data;
		},
	});
};

export default useInvoiceHistory;
